<template>
  <div
    class="fit-dialog"
    :class="[
      { 'fit-dialog-vertical': isValignBtn, 'fit-dialog-weui': data.weui, 'show-dlg': !data.hidden },
      data.theme,
    ]"
    v-on:click="onLayerClick"
    v-on:touchmove.prevent
  >
    <div class="flex-center">
      <div class="dlg-main" v-on:click.stop>
        <div class="dlg-bar" v-if="data.closeBtn">
          <i v-on:click="onClose" class="dlg-icon-close"></i>
        </div>
        <div class="dlg-content flex-v flex-center" :class="{ noBorder: data.btns.length <= 0 }">
          <div class="dlg-title" v-if="data.title">{{ data.title }}</div>
          <div class="dlg-text">
            <div v-if="this.$slots.default">
              <slot></slot>
            </div>
            <div v-else-if="data.htmlContent" v-html="data.htmlContent"></div>
            <div class="plain-text" v-else>{{ data.content }}</div>
          </div>
        </div>
        <div v-if="data.btns.length > 0" class="dlg-btns flex" :class="{ onlyBtn: data.btns.length == 1 }">
          <button v-for="(btn, index) in data.btns" v-on:click="bindTap(btn)" :key="'btn' + index" class="flex-1">
            {{ btn.text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../themes/default/dialog.css';
import base from '../../mixins/base.js';
export default {
  name: 'fit-dialog',
  mixins: [base],
  props: {
    title: {
      type: String,
      default: '',
    },
    htmlContent: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    btns: {
      type: Array,
      default() {
        return [];
      },
    },
    weui: {
      type: Boolean,
      default: false,
    },
    valignBtn: {
      type: Boolean,
      default: false,
    },
    closeBtn: {
      type: Boolean,
      default: false,
    },
    autoClose: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      data: {
        title: this.title,
        htmlContent: this.htmlContent,
        content: this.content,
        theme: this.theme,
        btns: this.btns || [],
        weui: this.weui,
        valignBtn: this.valignBtn,
        closeBtn: this.closeBtn,
        autoClose: this.autoClose,
        hidden: this.hidden,
      },
    };
  },
  computed: {
    isValignBtn() {
      let btn = null;
      if (this.data.valignBtn) {
        return this.data.valignBtn;
      }
      if (this.data.btns && this.data.btns.length > 2) {
        return true;
      }
      if (this.data.btns && this.data.btns.length === 2) {
        for (let i = this.data.btns.length - 1; i >= 0; i--) {
          btn = this.data.btns[i];
          if (btn && btn.text && btn.text.length > 14) {
            return true;
          }
        }
      }
      return false;
    },
    isHidden: {
      get() {
        return this.data.hidden;
      },
      set(value) {
        this.data.hidden = value;
        this.$emit('input', value);
      },
    },
  },
  watch: {
    title() {
      this.data.title = this.title;
    },
    htmlContent() {
      this.data.htmlContent = this.htmlContent;
    },
    content() {
      this.data.content = this.content;
    },
    theme() {
      this.data.theme = this.theme;
    },
    btns() {
      this.data.btns = this.btns || [];
    },
    weui() {
      this.data.weui = this.weui;
    },
    valignBtn() {
      this.data.valignBtn = this.valignBtn;
    },
    closeBtn() {
      this.data.closeBtn = this.closeBtn;
    },
    autoClose() {
      this.data.autoClose = this.autoClose;
    },
    hidden() {
      this.data.hidden = this.hidden;
    },
  },
  methods: {
    bindTap(btn) {
      if (btn && typeof btn.click === 'function') {
        btn.click();
      } else {
        this.hide();
      }
    },
    show(args) {
      if (sessionStorage.getItem('loggingIn') === '1') {
        return;
      }
      const self = this;
      if (args) {
        Object.keys(this.data).forEach((key) => {
          if (args.hasOwnProperty(key) && typeof this.data[key] === typeof args[key]) {
            this.data[key] = args[key];
          } else {
            const prop = this.$options.props[key];
            if (prop) {
              let defValue = prop.default;
              if ((prop.type === Object || prop.type === Array) && typeof defValue === 'function') {
                defValue = defValue.call(self);
              }
              this.data[key] = defValue;
            }
          }
        });
      }
      this.isHidden = false;
    },
    hide() {
      this.isHidden = true;
    },
    onClose() {
      this.hide();
    },
    onLayerClick(e) {
      if (this.data.autoClose) {
        this.hide();
      }
    },
  },
};
</script>
